/* script */
//
//
//
//
//
//
//
//
//
//
//

/**
 * A simple component that given a progress number shows a progress bar.
 *
 * @example
 * ProgressBar(:progress="progress")
 *
 * @vue-prop {Number} [progress=0] the current progress to display.
 * @vue-prop {Number} [precision=2] the precision we want to use when displaying the number.
 * @vue-prop {Boolean} [showNumber=false] shows percentage number above progress bar
 * @vue-prop {String} [label=''] label to show next to percentage number
 *
 * @category ui.components
 * @exports ProgressBar
 * @component
 */
const __vue_script__ = {
    name: 'ProgressBar',

    props: {
        progress: {
            type: Number,
            default: 0
        },
        precision: {
            type: Number,
            default: 2
        },
        showNumber: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    },

    computed: {
        numberLabel() {
            let label = `${this.progress.toFixed(this.precision)} %`;

            if (this.label) {
                label += ` - ${this.label}`;
            }

            return label;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-wrapper"},[(_vm.showNumber)?_c('div',{staticClass:"progress-label"},[_vm._v(_vm._s(_vm.numberLabel))]):_vm._e(),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({width: _vm.progress + '%'}),attrs:{"role":"progressbar","aria-valuenow":_vm.progress,"aria-valuemin":"0","aria-valuemax":"100"}})])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ProgressBar.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__